(function(){
    const metaEl = document.querySelector('meta[name="viewport"]');
    function setViewPort(){
        var pageWidth = 640; //css set page's width
        var windowScreenWidth = typeof window.screen.width == 'undefined' ? 0 : parseInt(window.screen.width, 10);
        windowScreenWidth = isNaN(windowScreenWidth) ? 0 : windowScreenWidth;

        if(windowScreenWidth > 0) {

            var scale = windowScreenWidth / pageWidth;
            // 判断是否是安卓 端
            var isAndroid = /Android[\/\s]+([\d\.]+)/i.test(navigator.userAgent);
            var aVersion = isAndroid ? RegExp.$1 : '0';
            
            if(isAndroid && aVersion < '5.0') {
                if(aVersion > '2.3') {
                    metaEl.setAttribute('content', 'width=' + 640 +  ',maximum-scale=' + scale +',minimum-scale=' + scale +', target-densitydpi=device-dpi' );
                    // document.write('<meta name="viewport" content="width=640, minimum-scale=' + scale + ', maximum-scale =' + scale +
                    // ', target-densitydpi=device-dpi" />');
                } else {
                    metaEl.setAttribute('content', 'width=' + 320 +  ',initial-scale=0.5, user-scalable=0' );
                    // document.write('<meta name="viewport" content="width=320, initial-scale=0.5, user-scalable=0" />');
                }
            } else {
                if(/(iphone|ipad|ios)/i.test(window.navigator.userAgent)) {
                    if(/ipad/i.test(window.navigator.userAgent)){
                        metaEl.setAttribute('content', 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0' );
                        // document.write('<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" />');
                    }else{
                        metaEl.setAttribute('content', 'width=device-width, user-scalable=0,initial-scale= '+ scale + ',minimum-scale=' + scale + ',maximum-scale=' + scale);
                        // document.write('<meta name="viewport" content="width=device-width, user-scalable=0, initial-scale=' + scale +',minimum-scale=' + scale + ',maximum-scale=' + scale + '" />');
                    }
                } else {
                    metaEl.setAttribute('content', 'width=640, user-scalable=0,target-densitydpi=device-dpi');
                    // document.write('<meta name="viewport" content="width=640, user-scalable=0, target-densitydpi=device-dpi" />');
                }
            }
        }
    }
    document.addEventListener('DOMContentLoaded', setViewPort)
})()